import { Component, OnInit, ViewChild } from '@angular/core';
import { User } from '@layout/components/classes/user';
import { NgForm } from '@angular/forms';
import { SchoolService } from '@app/school/school.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-subscribe',
  templateUrl: './subscribe.component.html',
  styleUrls: ['./subscribe.component.scss'],
})
export class SubscribeComponent implements OnInit {
  @ViewChild('contactForm')
  contactForm!: NgForm;
  submited: boolean = false;
  errorOccure: boolean = false;
  saved: boolean = false;
  email: any;
  ngform: any;
  userModel = new User('');
  lang='';
  constructor(private global: SchoolService , private toastr: ToastrService) {}

  ngOnInit(): void {
    console.log('ss');
    this.lang = localStorage.getItem('language') || 'en';
  }
  onSubmit(x: any) {
    if (x.valid) {
      this.submited = true;
      this.global.getStayInformed({ email: this.userModel.email }).subscribe(
        (res) => {
          console.log(res.Object);
          this.toastr.success(res.Object);
        },
        (err) => {
          console.log(err.error.errorMessage);
          this.toastr.error(err.error.errorMessage);
        }
      );
    }
    console.log(this.submited);
  }
}
